module.exports = __webpack_public_path__ + "static/grade-9e2bbfdec8074965601d66b6d154a139.png";